export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes5_buy.1df35fbb.mp3";